var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.close),expression:"close"}],staticClass:"VDropdownBlock"},[_vm._t("button",function(){return [_c('VButton')]}),_c('div',{staticClass:"VDropdownBlock-dropdown"},[_vm._t("dropdown")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }